module.exports = __webpack_public_path__ + "img/na.bc6f3459.svg";